import { defineComponent as _defineComponent } from 'vue'
import {ref} from 'vue';
import CityPicker from '@/components/CityPicker.vue';
import userStoreModule from '@/store/modules/user';
import {releaseProcessing} from '@/api/miscellaneous';
import {useRouter} from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReleaseProcessing',
  setup(__props, { expose }) {
  expose();

const router = useRouter();
const submitData = ref<any>({
    categoryId: 0,
    profile: '',
    areaId: userStoreModule.userDetail.areaId,
    address: [userStoreModule.userDetail.shortAddress],
    photos: [],
});
const isShowCityPicker = ref(false);
const cityConfirm = (data: any) => {
    submitData.value.areaId = data[2].value;
    submitData.value.address = data.map((el: {label: any}) => el.label);
};

const submit = () => {
    submitData.value.profile = '处理：' + submitData.value.profile;
    releaseProcessing(submitData.value).then(res => {
        submitData.value.profile = '';
        router.push({
            name: 'Result',
            query: {
                type: 'process',
                // title: '发布成功',
                // content: '您的发布已经成功，我们会尽快审核，请耐心等待',
                // btnText: '返回首页',
                // btnUrl: 'Home',
            },
        });
    });
};

const __returned__ = { router, submitData, isShowCityPicker, cityConfirm, submit, ref, CityPicker, userStoreModule, releaseProcessing, useRouter }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})